<template>
  <section class="legal-page py-5">
    <b-container>
      <h1 class="jd-text-dark jd-font-bold jd-text-36 jd-text-25__mobile text-center">Privacy Policy</h1>

      <p class="jd-text-18 jd-text-dark mt-4">
        This Privacy Policy governs the manner in which Junk Deal collects, uses, maintains and discloses
        information collected from users (each, a "User") of the https://www.junkdeal.com website ("Site").
        This privacy policy applies to the Site and all products and services offered by Junk Deal.
      </p>

      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Personal identification information</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        We may collect personal identification information from Users in a variety of ways, including, but not limited
        to,
        when Users visit our site, fill out a form, and in connection with other activities, services, features or
        resources
        we make available on our Site. Users may be asked for, as appropriate, name, email address, phone number. Users
        may,
        however, visit our Site anonymously. We will collect personal identification information from Users only if they
        voluntarily submit such information to us. Users can always refuse to supply personally identification
        information,
        except that it may prevent them from engaging in certain Site related activities.
      </p>

      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Non-personal identification information</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        We may collect non-personal identification information about Users whenever they interact with our Site.
        Non-personal identification information may include the browser name, the type of computer and technical
        information about Users means of connection to our Site, such as the operating system and the Internet service
        providers utilized and other similar information.

      </p>

      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Web browser cookies</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        Our Site may use “cookies” to enhance User experience. User’s web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.
      </p>


      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">How we use collected information</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        Junk Deal may collect and use Users personal information for the following purposes:
      </p>

      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">How we protect your information</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized
        access, alteration, disclosure or destruction of your personal information, username, password, transaction information and
        data stored on our Site.
      </p>


      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Sharing your personal information</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above.
      </p>

      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Third party websites</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        Users may find advertising or other content on our Site that link to the sites and services of our partners, suppliers, advertisers, sponsors, licensors and other third parties. We do not control the content or links that appear on these sites and are not responsible for the practices employed by websites linked to or from our Site. In addition, these sites or services, including their content and links, may be constantly changing. These sites and services may have their own privacy policies and customer service policies. Browsing and interaction on any other website, including websites that have a link to our Site, is subject to that website’s own terms and policies.
      </p>

      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Changes to this privacy policy</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        Junk Deal has the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.
      </p>

      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Your acceptance of these terms</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        By using this Site, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our Site. Your continued use of the Site following the posting of changes to this policy will be deemed your acceptance of those changes.
      </p>

      <h2 class="jd-text-dark jd-font-medium jd-text-22 mt-4">Contacting us</h2>
      <p class="jd-text-18 jd-text-dark mt-2">
        If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us at:
      </p>
      <address class="jd-text-18 jd-text-dark">
        Junk Deal<br>
        3641 Haven Ave, Suite C, Menlo Park, CA 94025<br>
        <a href="mailto:info@junkdeal.com">info@junkdeal.com</a><br>
        <a href="tel:6509957500">650-995-7500</a>
      </address>
    </b-container>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      titleTemplate: '%s',
      title: 'Privacy Policy',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Junk Deal Privacy Policy'
        }
      ]
    };
  },
  mounted() {
    this.$root.$emit('hideLoader');
  }
}
</script>
